export default "__VITE_ASSET__BcjnocJj__"